import { ThemeFont } from './types';
import { FONT_FAMILY_MAP } from './constants';

export function getFontFamily(font: ThemeFont): string {
  return FONT_FAMILY_MAP[font.name] || font.name;
}

export function getAppliedFontFamily(
  previewStyle: { fontId?: string } | undefined,
  allFonts: ThemeFont[],
): string {
  if (!previewStyle?.fontId) {
    return 'inherit';
  }
  const font = allFonts.find((f) => f.id === previewStyle.fontId);
  return font ? getFontFamily(font) : 'inherit';
}

export function getFontImport(font: ThemeFont): string {
  if (!font.url) {
    return '';
  }
  return `@import url("${font.url}");`;
}
